import {
  Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit, OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService, VariablesService, VwoService } from '../../../../shared/services';
import { ICart } from '../../models/cart.model';
import { Subject, Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IContribute } from '../../models/contribute.model';
import { PaymentUtilService } from '../../services';
import { IPaymentConfig } from '../../models/payment.model';

@Component({
  selector: 'app-slabs',
  templateUrl: './slabs.component.html',
  styleUrls: ['./slabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SlabsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() currency;
  @Input() params;
  @Input() reward;
  @Input() isReward;
  @Input() type;
  @Input() setOtherAmount: Subject<any>;
  @Input() contributeDetails: IContribute;
  @Input() checkForOtherCases = true;
  @Input() showSlabNameTag;
  @Input() recommendTag;
  @Input() payment_config: IPaymentConfig;
  @Input() tagLabel;
  @Input() theme;
  @Input() isQR;
  @Output() userSelectionCurrency: EventEmitter<any> = new EventEmitter();
  @Output() amountChange: EventEmitter<any> = new EventEmitter();
  slabs = [];
  amountForm: FormGroup;
  amount: FormControl;
  otherAmountLabel = 'Other Amount';
  @ViewChild('otherAmountBtnRef') public otherAmountBtnRef;
  @ViewChild('otherAmountRef') public otherAmountRef: ElementRef<HTMLElement>;
  @ViewChild('amountRef') public amountRef: ElementRef<HTMLInputElement>;
  otherAmountSelected = false;
  language;
  nudge;

  max_donation = 50000000;

  subs: Subscription[] = [];

  constructor(
    private actiRoute: ActivatedRoute,
    private storageService: StorageService,
    private paymentUtilService: PaymentUtilService,
    public variablesService: VariablesService,
    public vwo: VwoService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contributeDetails'] && !changes['contributeDetails']['firstChange']) {
      this.updateMinValidation();
      this.slabConditions();
    }
  }
  ngOnInit() {
    this.variablesService.languageObs.subscribe((currentlang) => {
      this.language = currentlang;
    });
    if (this.isQR?.name === 'UPI') {
      this.max_donation = 100000
    }
    this.setConfig();
    this.amountForm = new FormGroup({
      amount: this.amount = new FormControl('', [
        Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(this.contributeDetails.min_donation), Validators.max(this.max_donation)
      ]),
    });
    if (this.vwo.new_slab_AB() && (this.currency !== 'INR' || this.params?.utm_source === 'direct')) {
      const newSlabs = { INR: [500, 650, 900], USD: [35, 60, 90], GBP: [30, 45, 70], EUR: [30, 45, 70], AED: [130, 220, 330], SAR: [135, 226, 340], SGD: [50, 80, 120] };
      this.contributeDetails.slabs = newSlabs[this.currency];
      this.contributeDetails.default_amount = newSlabs[this.currency][1];
    }
    this.slabConditions();
    this.paymentUtilService.selectedReward.subscribe({
      next: (res) => {
        if (res) {
          this.reward = res;
          this.amount.setValue(this.reward.amount);
        }
      }
    });
    this.amount.valueChanges.subscribe((res) => {
      this.amountChange.next(res || 0)
    });
  }

  setConfig() {
    this.subs.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
      }
    }));
  }

  ngAfterViewInit() {
    if (this.isReward) {
      setTimeout(() => {
        this.otherAmountAnimate();
        this.amountRef.nativeElement.focus();
      }, 0);
    }
  }

  // Update min validation on currency change
  updateMinValidation() {
    this.amount.setValidators([
      Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(this.contributeDetails.min_donation), Validators.max(this.max_donation)
    ]);
  }

  /**Slab conditions */
  slabConditions() {
    if (this.params.st === 'f') {
      const cartData = this.storageService.getFromSession('cartData');
      this.setSlabs(this.contributeDetails.slabs, cartData.donated_amount);
    } else if (this.isReward) {
      this.amount.setValue(this.reward ? this.reward.amount : this.contributeDetails.default_amount);
      this.amountChange.next(this.reward ? this.reward.amount : this.contributeDetails.default_amount);
    } else {
      this.amount.setValue(this.contributeDetails.default_amount);
      this.amountChange.next(this.contributeDetails.default_amount);
      this.setSlabs(this.contributeDetails.slabs, this.contributeDetails.default_amount);
    }
  }
  /**set the slabs */
  setSlabs(slabs: any[], defaultAmount) {
    if (defaultAmount < this.contributeDetails.min_donation) { defaultAmount = this.contributeDetails.default_amount; }
    this.slabs = [];
    const qParams = this.actiRoute.snapshot.queryParams;
    this.amount.setValidators([
      Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(this.contributeDetails.min_donation), Validators.max(this.max_donation)
    ]);
    // adding 100Rs on activating 100rs coupon when utm_source=wallet_offer_100 popup is clicked
    const setAmount = { amount: this.paymentUtilService.utmProceedClicked ? defaultAmount + 100 : defaultAmount, isSelected: false };
    for (const slab of slabs) {
      // adding 100Rs on activating 100rs coupon when utm_source=wallet_offer_100 popup is clicked
      const slabData = {
        amount: this.paymentUtilService.utmProceedClicked ? slab + 100 : slab,
        isSelected: slab === defaultAmount ? true : false
      };
      this.slabs.push(slabData);
    }
    // this.slabs[0].name_tag = 'POCKET FIRENDLY';
    // this.slabs[1].name_tag = 'MOST POPULAR';
    // this.slabs[2].name_tag = 'COMMITTED DONOR';

    if (this.checkForOtherCases) {
      if (qParams.donated_amount) {
        this.setAmountIfFailed(slabs, +qParams.donated_amount, { amount: +qParams.donated_amount, isSelected: false });
      } else if (qParams.abandon) {
        this.setAmountIfFailed(slabs, +qParams.amount, { amount: +qParams.amount, isSelected: false });
      } else if (this.storageService.getFromSession(this.params.oi)) {
        const cart: ICart = this.storageService.getFromSession(this.params.oi);
        this.setAmountIfFailed(slabs, cart.donated_amount, setAmount);
      } else {
        this.setAmount(setAmount);
      }
    } else {
      this.setAmount(setAmount);
    }
  }

  /**If tansaction is failed then set the failed amount */
  setAmountIfFailed(slabs, donated_amount, setAmount) {
    this.setAmount(setAmount);
    if (slabs.indexOf(donated_amount) !== -1) {
      for (const slab of this.slabs) {
        slab.isSelected = slab.amount === donated_amount ? true : false;
      }
    } else {
      this.otherAmountAnimate();
    }
  }

  /**Set the amount to donate */
  setAmount(slab) {
    for (const item of this.slabs) {
      item.isSelected = item.amount === slab.amount ? true : false;
    }
    this.amount.setValue(slab.amount);
    this.amountChange.next(slab.amount);
    if (this.vwo.other_amount_AB() && this.amount?.value < this.contributeDetails?.slabs[2] && !this.storageService?.getFromSession('nudge') && this.otherAmountSelected) {
      this.nudge = true;
    }
  }

  /**Animated the other amount button, by clicking on it */
  otherAmountAnimate() {
    for (const slab of this.slabs) {
      slab.isSelected = false;
    }
    if (this.otherAmountBtnRef) {
      this.otherAmountBtnRef._elementRef.nativeElement.style.width = '100%';
      this.otherAmountSelected = true;
      this.otherAmountLabel = '';
      this.otherAmountRef.nativeElement.style.display = 'unset';
    }
    if (this.vwo.other_amount_AB() && this.amount?.value < this.contributeDetails?.slabs[2] && !this.storageService?.getFromSession('nudge')) {
      this.nudge = true;
    }
  }
  /**Set the user selected currency */
  setCurrency(data) {
    this.userSelectionCurrency.emit(data);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
